import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { CachedDataService } from '@services/data/cached-data.service';
import { Observable } from 'rxjs/Observable';
import { DeviceState } from '@models/device-state';
import { BaseHttpService } from '@services/http/base-http.service';
import { Router } from '@angular/router';
import { AuthService } from '@services/http/auth.service';
import { Subject } from 'rxjs/Subject';


import { StatsItem, Track, StatsTrack, DeviceEvent, Geozone, Location } from '@models';

/*Eenvironment */
import { environment } from '@environments';

@Injectable()
export class GeozoneService extends BaseHttpService {
 


  constructor(protected httpClient: HttpClient,
    protected cachedDataService: CachedDataService,
    protected router: Router,
    protected authService: AuthService) {
    super(httpClient, cachedDataService, router, authService);
  }

  getGeozone(providerAccountId: string): Observable<Array<Geozone>> {
    const uri = environment.apiUri + 'geozone';
    const params = new HttpParams()
    .set('providerAccountId', providerAccountId)

    return super.send('GET', uri, params);
  }

  updateGeozone(providerAccountId: string, name: string, id: string, points: Array<Location>, isActive: boolean, isSms: boolean): Observable<any> {
    const uri = environment.apiUri + 'geozone';

    const body = {
      providerAccountId: providerAccountId,
      name: name,
      points: points,
      id: id,
      isActive: isActive,
      isSms: isSms
    };
    return super.send('PUT', uri, null, true, body);
  }

  addGeozone(providerAccountId: string, name: string, points: Array<Location>): Observable<any> {
    const uri = environment.apiUri + 'geozone';

    const body = {
      providerAccountId: providerAccountId,
      name: name,
      points: points
    };
    return super.send('POST', uri, null, true, body);
  }
  deleteGeozone(providerAccountId: string, geozoneId: string): Observable<Array<Geozone>> {
    const uri = environment.apiUri + 'geozone';
    const params = new HttpParams()
    .set('providerAccountId', providerAccountId)
    .set('geozoneId', geozoneId)

    return super.send('DELETE', uri, params);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/http/geozone.service.ts